import axios from 'axios'

export const getAllInvoice = (params) => {
  return axios.get('/invoices', {
    params: params
  })
}

export const getInvoice = (id, params) => {
  return axios.get('/invoices/' + id, {
    params: params
  })
}

export const getTotalDebt = (params) => {
  return axios.get('/invoices/total-debt', {
    params: params
  })
}

export const getTotalDebtByFilter = (params) => {
  return axios.get('/invoices/total-debt-filters', {
    params: params
  })
}

export const createInvoice = (data) => {
  return axios.post('/invoices', data)
}

export const editInvoice = (id, data) => {
  return axios.put('/invoices/' + id, data)
}

export const deleteInvoice = (id) => {
  return axios.delete('/invoices/' + id)
}

export const getHelpers = () => {
  return axios.get('/helpers/invoices')
}

export const confirmInvoice = (id) => {
  return axios.put('invoices/' + id + '/confirm')
}

export const confirmAllInvoice = (ids) => {
  return axios.post('invoices/confirm_all', ids)
}

export const paymentInvoice = (id) => {
  return axios.put('invoices/' + id + '/payment')
}

export const hardPaymentInvoice = (id) => {
  return axios.put('invoices/' + id + '/hard-payment')
}

export const returnInvoice = (id, data) => {
  return axios.put('invoices/' + id + '/return', data)
}

export const exportExcel = (params) => {
  return axios.get('invoices/export-excel', {
    params: params
  })
}

export const resendEmail = (id) => {
  return axios.get('invoices/' + id + '/resend-email')
}

export const exportAllInvoice = (ids) => {
  return axios.post('invoices/export_all', ids)
}

export const paymentAllInvoice = (ids) => {
  return axios.post('invoices/payment_all', ids)
}

export const makePaymentExtra = (id, data) => {
  return axios.post(`invoices/${id}/payment-extra`, data)
}

const axiosInstance = axios.create({
  baseURL: process.env.EXPORT_LISTING_ZH_URL,
  timeout: 1000 * 60 * 2,
  headers: {
    'Authorization': `Bearer ${process.env.EXPORT_LISTING_ZH_KEY}`
  }
})

export const exportCodListing = (params) => {
  return axiosInstance.get('/shipments/export-cod-listing', {
    params: params,
    responseType: 'blob'
  })
}

export const exportFeeListing = (params) => {
  return axiosInstance.get('/shipments/export-fee-listing', {
    params: params,
    responseType: 'blob'
  })
}

export const exportCompareFeeListing = (params) => {
  return axiosInstance.get('/shipments/export-compare-fee-listing', {
    params: params,
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/api/invoice.js